module.exports = __webpack_public_path__ + "static/media/checkIcon.6e45ac35.svg";